// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip--TQPOh","tooltip-light":"tooltip-light--uFP8Q"};